export default {
  defaultLocale: "en-US", // 'he-IL', 'en-US'
  availableLocales: ["he-IL", "en-US"],
};
